// eslint-disable-next-line import/no-unresolved
import ApiSearchResponse from 'prismic-javascript/types/ApiSearchResponse'

export const prismicHomePageContent: ApiSearchResponse = {
  page: 1,
  results_per_page: 20,
  results_size: 2,
  total_results_size: 2,
  total_pages: 1,
  next_page: 'null',
  prev_page: 'null',
  results: [
    {
      id: 'Xvyn1REAACMAsLcN',
      uid: 'null',
      type: 'home_page_updates',
      href: 'https://world-community-grid.cdn.prismic.io/api/v2/documents/search?ref=X_XcGxEAACMAsRlP&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22Xvyn1REAACMAsLcN%22%29+%5D%5D',
      tags: [],
      first_publication_date: '2020-07-01T15:12:26+0000',
      last_publication_date: '2021-01-06T15:49:47+0000',
      slugs: ['africa-rainfall-project-makes-plans-for-data-storing-and-sharing', 'this-is-how-a-global-community-unites-to-find-cancer-biomarkers.'],
      lang: 'en-us',
      alternate_languages: [],
      data: {
      body: [
          {
            primary: {
              subject: 'Research Update from the MCM Team (October 2025)',
              summary: 'PDE8B, a gene that is involved in hormone synthesis and has altered expression in diverse cancers.',
              date: '2025-10-28',
              image: {
                url: '/images/prismic/mcm1_NELL2_fig1.png',
              },
              link: 'https://worldcommunitygrid.org/about_us/article.s?articleId=827',
            },
          },
          {
            primary: {
              subject: 'Research Update from the ARP Team (July 2025)',
              summary: 'We are excited to share an update on ARP which has been back up and running since Fall 2024.',
              date: '2025-07-08',
              image: {
                url: '/images/prismic/arp1_restart_wudist_only.jpg',
              },
              link: 'https://www.worldcommunitygrid.org/about_us/article.s?articleId=824',
            },
	  },
          {
            primary: {
              subject: 'Research Update from the MCM Team (July 2025)',
              summary: 'Spotlight on a Top-Scoring predictive gene from analysis of MCM gene signatures, Ecdysoneless Cell Cycle Regulator (ECD) regulates cell growth and repair.',
              date: '2025-07-14',
              image: {
                url: '/images/prismic/mcm1_ecd_fig1_nocaption_highres.jpg',
              },
              link: 'https://worldcommunitygrid.org/about_us/article.s?articleId=825',
            },
          },
        ],
      },
    },
    {
      id: 'Xvu1qxEAACMArIvY',
      uid: 'null',
      type: 'home_page_hero',
      href: 'https://world-community-grid.cdn.prismic.io/api/v2/documents/search?ref=X_XcGxEAACMAsRlP&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22Xvu1qxEAACMArIvY%22%29+%5D%5D',
      tags: [],
      first_publication_date: '2020-06-30T22:02:11+0000',
      last_publication_date: '2021-01-05T19:32:17+0000',
      slugs: ['home--world-community-grid', 'kevin--home--world-community-grid', 'aids-is-constantly-evolving.so-are-the-tools-to-fight-it.'],
      lang: 'en-us',
      alternate_languages: [],
      data: {
        page_title: 'Home | World Community Grid',
        page_description:
          'World Community Grid enables anyone with a computer or Android device to donate their unused computing power to advance cutting-edge scientific research on topics related to health and sustainability.',
        social_image: '/images/logo_images/wcg_logo_square_new_200x200.png',
        background_image: {
          url: '/images/prismic/transitionBig.jpg',
        },
        headline: [
          {
            type: 'paragraph',
            text: 'Celebrating 20 years of World Community Grid',
            spans: [],
          },
          {
            type: 'paragraph',
            text: '',
            spans: [],
          },
        ],
        summary: 'Enabling seemingly impossible scientific research to come to life',
        text_color: 'White',
        image_overlay_style: 'None',
        body: [
          {
            slice_type: 'learn_more',
            primary: {
              link: 'https://www.worldcommunitygrid.org/about_us/article.s?articleId=816',
            },
          },
          /* prettier-ignore */
          /* This enables the "join" a project button on the home page, uncomment to add it back
          {
            slice_type: 'contribute_link',
            primary: {
              project_short_name: 'opn1',
            },
          },*/
        ],
      },
    },
  ],
}
